import React from 'react';
import { Time } from './Time';

interface MonthProps {
  /**
   * The date string to be displayed. Can be any valid date string parseable by Date.parse().
   */
  date: string;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;
}

/**
 * Month component for displaying the full month name of a date.
 * Uses toLocaleString to format the month name.
 * @param props The component props.
 * @returns JSX.Element
 */
export const Month: React.FC<MonthProps> = ({ date, className }) => {
  const timestamp = Date.parse(date);
  const dateObject = new Date(timestamp);
  const monthName = dateObject.toLocaleString('en-US', { month: 'long' });

  return (
    <Time date={date} className={className}>
      {monthName}
    </Time>
  );
};
